
import { config } from './config';

const FRAMES_PER_SECOND = config.defaultFramesPerSecond;

/**
 * Salta un frame hacía la dirección seleccionada
 * @param {HTMLVideoElement} video 
 * @param {shaka.Player} player 
 * @param {1 | -1} dir  1 o -1
 * @param {number} fps  fotogramas por segundo
 */
export function stepFrame(video, player, dir, fps = FRAMES_PER_SECOND) {
    if (!video.paused) video.pause();

    const frame = 1 / fps;
    const { start, end } = player.seekRange();

    // Ajusta al frame actual para evitar deriva, +0.5 frame para caer dentro del frame
    const current = Math.floor(video.currentTime * fps) / fps;
    const target = current + dir * frame + frame / 2;

    video.currentTime = Math.min(Math.max(target, start), end - frame / 2);
}

/**
 * Formatea el tiempo en formato timecode (hh:mm:ss:ff)
 * @param {number} time Tiempo en segundos
 * @param {number} fps Fotogramas por segundo
 * @returns {string} Tiempo en formato timecode
 */
export function formatTimecode(time, fps = FRAMES_PER_SECOND) {
    const nominalFps = Math.max(1, Math.round(fps)); // 29.97 -> 30, 23.976 -> 24
    // Small epsilon so 1.0000000001 * fps doesn't fall to the previous frame
    const totalFrames = Math.floor(Math.max(0, time) * fps + 1e-6);

    const frames = totalFrames % nominalFps;
    const totalSeconds = Math.floor(totalFrames / nominalFps);
    const ss = totalSeconds % 60;
    const mm = Math.floor(totalSeconds / 60) % 60;
    const hh = Math.floor(totalSeconds / 3600);

    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(hh)}:${pad(mm)}:${pad(ss)}:${pad(frames)}`;
}